module.exports = __webpack_public_path__ + "img/carlinear.dda20430.png";